import styled from 'styled-components';

import Picture from 'components/picture';

export const DoubleActionBtnWrapper = styled.div`
  display: flex;
  align-content: flex-end;
  margin-top: -1.8rem;
  position: relative;
  ${Styles.desktop`
    top: 0;
    margin-top: 3rem;
  `}
`;

export const WhiteBGWrapper = styled.div`
  background: ${Styles.color.white};
  display: flex;
  padding: 3px 2px;
  width: 100%;
  ${Styles.desktop`
    width: unset;
  `}
`;

export const Icon = styled(Picture)`
  width: 23px;
  height: 19px;
  border-radius: unset;
`;

export const LeftDesktopBtnWrapper = styled.div`
  margin-left: 20px;
`;
